"use client";

import { filter, isEmpty } from "lodash";
import {
  Dispatch,
  FC,
  PropsWithChildren,
  SetStateAction,
  useEffect,
  useMemo,
  useState,
} from "react";

import { createCustomContext } from "./context";
import { useUndressContext } from "./UndressProvider";

export enum ETool {
  RUBBER = "rubber",
  BRUSH = "brush",
  NONE = "none",
}

interface Props {
  isShowDraw: boolean;
  onToggleShowDraw: () => void;
  brushSize: number;
  setBrushSize: Dispatch<SetStateAction<number>>;
  currentTool: ETool;
  setTool: Dispatch<SetStateAction<ETool>>;
  isUndoDraw: boolean;
  setUndoDraw: Dispatch<SetStateAction<boolean>>;
  isCleanDraw: boolean;
  setCleanDraw: Dispatch<SetStateAction<boolean>>;
  isMaskLoading: boolean;
  startLoading: (id: string) => void;
  stopLoading: (id: string) => void;
}

const [Context, useAutoMaskContext] = createCustomContext<Props>({
  name: "AutoMaskContext",
});
export { useAutoMaskContext };

export const AutoMaskProvider: FC<PropsWithChildren> = ({ children }) => {
  const { setLoading } = useUndressContext();

  // Состояние для отображения рисования
  const [isShowDraw, setShowDraw] = useState(false);

  const onToggleShowDraw = () => {
    setShowDraw(!isShowDraw);
  };

  // Состояние для размера кисти
  const [brushSize, setBrushSize] = useState(10);

  // Состояние для текущего инструмента рисования
  const [currentTool, setTool] = useState<ETool>(ETool.BRUSH);

  // Состояние для управления отменой действия
  const [isUndoDraw, setUndoDraw] = useState(false);

  // Состояние для управления очисткой маски
  const [isCleanDraw, setCleanDraw] = useState(false);

  // Состояние "загрузки" для маультимасок
  const [loadingIds, setLoadingIds] = useState<string[]>([]);

  const isMaskLoading = useMemo(() => !isEmpty(loadingIds), [loadingIds]);

  const startLoading = (id: string) => {
    setLoadingIds((prev) => [...prev, id]);
  };
  const stopLoading = (id: string) => {
    setLoadingIds((prev) => filter(prev, (loadingId) => loadingId !== id));
  };

  // Управляем глобальным стейтом загрузки
  useEffect(() => {
    if (isMaskLoading) {
      setLoading(true);
    } else {
      setLoading(false);
    }
  }, [isMaskLoading, setLoading]);

  return (
    <Context
      value={{
        isShowDraw,
        onToggleShowDraw,
        currentTool,
        setTool,
        brushSize,
        setBrushSize,
        isUndoDraw,
        setUndoDraw,
        isCleanDraw,
        setCleanDraw,
        isMaskLoading,
        startLoading,
        stopLoading,
      }}
    >
      {children}
    </Context>
  );
};
